module.exports = {
    datetimePickerConfigApp: {
        enableTime: true,
        time_24hr: true,
        enableSeconds: true,
        dateFormat: 'Y-m-d H:i:S',
        altInput: true,
        altFormat: 'd/m/Y H:i:S',
        locale: 'UTC'
    },
    datePickerConfigApp: {
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd/m/Y',
        locale: null
    },
    dateFormat: {
        DMYHIS_SLASH : "DD/MM/YYYY HH:mm:ss",
        ymdhis :  "YYYY-MM-DD HH:mm:ss"
    },
    DMY_SLASH : "DD/MM/YYYY",
    DMYHI_SLASH : "DD/MM/YYYY HH:mm",
    $_debounceTimer:null,
    options: [],
}